export default __webpack_public_path__ + "static/media/brainhealth-project-logo-dark.4b389a1f.svg";